const mutations = {
  setCommunications(state, payload) {
    state.communications = payload;
  },
  setGeneralMaster(state, payload) {
    state.generalMaster = payload;
  },
  setPlanLists(state, payload) {
    state.planLists = payload;
  },
  setCreatescheduleForm(state, payload) {
    state.createScheduleForm.scheduleNo = payload.scheduleNo;
    state.createScheduleForm[payload.type] = payload.form;
  },
  setScheduleFormDetail(state, payload) {
    state.scheduleSectionData = payload;
  },
  setPayoutCommunicationDropDownData(state, payload) {
    state.payoutCommunicationDropDownData = payload;
  },
  setpartialPayoutDateItem(state, payload) {
    state.partialPayoutDateItemData = payload;
  },
  setPreviousPayoutCommunicationsForProgram(state, payload) {
    state.previousPayoutCommunicationsForProgramData = payload;
  },
  setStorePreviousPastCommu(state, payload) {
    state.storePreviousPastCommu = payload;
  },
  setPayoutCommInProgressAsync(state, payload) {
    state.payoutCommInProgressAsync = payload;
  }
};

export default mutations;
